import iconImg from "@PUBLIC/M/images/ico/ico_sns.png";
import styled, {css} from "@yb/styled-px2rem";

interface SnsProps {
	sns: "facebook" | "twitter" | "kakaoStory" | "naver" | "kakaoTalk" | "email";
}

const ShareWrap = styled.div`
	display: flex;
	flex-direction: column;
`;
const SnsBtnList = styled.ul`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 40px;
	margin-bottom: 15px;
`;
const SnsBtnItem = styled.li`
	+ li {
		margin-left: 10px;
	}
`;
const SnsBtnLink = styled.a<SnsProps>`
	display: block;
	width: 40px;
	height: 40px;
	background-image: url(${iconImg});
	background-position: ${props => {
		if (props.sns === "facebook") {
			return css`0 0`;
		}
		if (props.sns === "twitter") {
			return css`-47px 0`;
		}
		if (props.sns === "kakaoStory") {
			return css`-94px 0`;
		}
		if (props.sns === "naver") {
			return css`-141px 0`;
		}
		if (props.sns === "kakaoTalk") {
			return css`-188px 0`;
		}
		if (props.sns === "email") {
			return css`-233px 0`;
		}
	}};
	background-size: auto 40px;
	> span {
		font-size: 0;
	}
`;
const LinkInputBlock = styled.div`
	display: flex;
	align-items: center;
	flex: 0 0 auto;
	padding-top: 15px;
	> button {
		margin-left: 8px;
	}
`;

export {ShareWrap, SnsBtnList, SnsBtnItem, SnsBtnLink, LinkInputBlock};
